// alertUtility.js
export function showAlert(message) {
  const alertBox = document.createElement("div");

  // Set the HTML content
  alertBox.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="alert-message ftw-4 common-text">${message}</span>
      </div>
    `;

  // Style the alert container
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.top = "100px";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#FFF";
  alertBox.style.border = "1px solid rgba(255, 0, 0, 0.20)";
  alertBox.style.boxShadow = "0px 8px 15px 0px rgba(255, 0, 0, 0.20)";
  alertBox.style.borderRadius = "13px";
  alertBox.style.padding = "12px 16px";
  // alertBox.style.maxWidth = '480px';
  // alertBox.style.width = '90%';
  alertBox.style.boxSizing = "border-box";
  alertBox.style.zIndex = "99999";
  alertBox.style.animation = "slideDown 0.3s ease-out forwards";

  // Add animation keyframes
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      .alert-message {
        font-size: 0.875rem;
      }
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
      @keyframes fadeOut {
        from {
          opacity: 1;
          transform: translate(-50%, 0);
        }
        to {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
      }
      
    `;
  document.head.appendChild(styleSheet);

  // Add the alert to the page
  document.body.appendChild(alertBox);

  // Add the alert-box class to the alertBox element
  alertBox.classList.add("alert-box");

  // Remove the alert after 3 seconds
  setTimeout(() => {
    alertBox.style.animation = "fadeOut 0.3s ease-out forwards";
    setTimeout(() => {
      document.body.removeChild(alertBox);
      document.head.removeChild(styleSheet);
    }, 300);
  }, 3000);
}
